import * as React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SettingsIcon from '@material-ui/icons/Settings';
import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles({
  buttonStyleFilled: {
    background: '#F62459',
    color: '#FFF',
    minWidth: '46px',
    '&:hover': {
      background: '#C93756'
    },
  },
});

export default function TransferMenu({
  onChangeNameClick, onSellTicketClick, canChangeName, isResaleEnabled, isTransferFeePaid, isTransferEnabled,
  onEnableTransfer, onDisableTransfer,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!canChangeName && !isResaleEnabled && !isTransferFeePaid) {
    return null;
  }

  return (
    <div>
      <Button
        className={classes.buttonStyleFilled}
        onClick={handleClick}
      >
        <SettingsIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {canChangeName && <MenuItem
          onClick={() => {
            onChangeNameClick();
            handleClose();
          }}
        >Change Name</MenuItem>}
        {isTransferFeePaid ? (
          [
            isTransferEnabled ?
              (<MenuItem key="disable-transfer-btn" onClick={() => {
                onDisableTransfer();
                handleClose();
              }}>Disable Transfer</MenuItem>) :
              (<MenuItem key="enable-transfer-btn" onClick={() => {
                onEnableTransfer();
                handleClose();
              }}>Enable Transfer</MenuItem>),
            <MenuItem key="update-transfer-btn" onClick={() => {
              onSellTicketClick();
              handleClose();
            }}>Transfer/Sell Options</MenuItem>,
          ]
        ) : (
          isResaleEnabled && <MenuItem onClick={() => {
            onSellTicketClick();
            handleClose();
          }}>Transfer/Sell Ticket</MenuItem>
        )}
      </Menu>
    </div>
  );
}
